import { useContext, useMemo } from "react";
import { ScreenContext } from "@foundation/screen";

export function useOnDesktop(): boolean {
  const {
    breakpoints: { smallDesktop, largeDesktop },
  } = useContext(ScreenContext);

  return useMemo(
    () => smallDesktop === true || largeDesktop === true,
    [smallDesktop, largeDesktop]
  );
}

export function useBreakpointDetectionPending(): boolean {
  const {
    breakpoints: { tablet, smallDesktop, largeDesktop },
  } = useContext(ScreenContext);

  return useMemo(
    () => smallDesktop === null && largeDesktop === null && tablet === null,
    [smallDesktop, largeDesktop, tablet]
  );
}
